module.exports = __webpack_public_path__ + "static/media/electricity.6f20cc52.png";